import { render, staticRenderFns } from "./notes.html?vue&type=template&id=d8553424&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"
import style0 from "./notes.vue?vue&type=style&index=0&id=d8553424&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8553424",
  null
  
)

export default component.exports